<script>
import { mapGetters } from "vuex";

import { createRefuelApply, updateRefuelApply } from "@/api/vehicle";
import { showPhoneAlarm } from "@/global/function.js";

import CarSearch from "./CarSearch.vue";
export default {
  components: { CarSearch },
  props: {
    visible: Boolean,
    isUpdate: Boolean,
    defaultValue: {
      type: Object,
      default: function () {
        return {};
      },
    },
    refuelOption: {
      type: Object,
      default: function () {
        return { max: 0, min: 0 };
      },
    },
    refuelTypeList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    const form = {
      data: {},
      rules: {
        refuelTypeCode: [
          { required: true, message: "请选择加油类型", trigger: "onChange" },
        ],
        applyRefuelCap: [
          { required: true, message: "请输入加油量", trigger: "onChange" },
        ],
      },
    };

    return {
      form,
      showCarSelect: false,
      showRefuelPicker: false,
      showNumberInput: false,
    };
  },
  computed: {
    ...mapGetters({
      userid: "user/userid",
    }),
    showPop: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    refuelDict() {
      return this.refuelTypeList.map((dict) => ({
        name: dict.label,
        value: dict.code,
      }));
    },
    title() {
      return this.isUpdate ? "编辑" : "新增" + "加油申请";
    },
    requelOpt() {
      return this.refuelOption;
    },
  },
  watch: {
    defaultValue: function (value) {
      if (typeof value === "object") {
        if (Object.keys(value).length) {
          this.form.data = {
            ...value,
            applyRefuelCap: "" + (value.applyRefuelCap || ""),
            isInterior: +value.isInterior ? true : false,
          };
        } else {
          this.form.data = { applyRefuelCap: this.refuelOption.max };
        }
      }
    },
  },
  created() {},
  methods: {
    async onSubmit() {
      if (!this.form.data.vehicleId) {
        this.$message({
          type: "info",
          message: "请选择车辆后提交",
        });
        return;
      }
      const payload = {
        id: this.form.data.id,
        vehicleId: this.form.data.vehicleId,
        vehicleNo: this.form.data.vehicleNo,
        vehicleName: this.form.data.vehicleName,
        refuelTypeCode: this.form.data.refuelTypeCode,
        refuelStatus: this.form.data.refuelStatus,
        isInterior: this.form.data.isInterior === true ? 1 : 0,
        applyRefuelCap: +this.form.data.applyRefuelCap,
        applyUserId: this.userid,
      };

      let response = undefined;
      if (this.isUpdate)
        response = await updateRefuelApply(payload).catch(() => false);
      else response = await createRefuelApply(payload).catch(() => false);

      if (response) {
        const { data } = response;
        if (
          showPhoneAlarm(
            true,
            "toast",
            null,
            2000,
            data.code,
            "新增加油申请",
            data.message
          )
        ) {
          this.$emit("success");
        }
      }
    },
    validatorRefuelNum(num) {
      return +num <= this.refuelOption.max && +num >= this.refuelOption.min;
    },
    handleSelected(value) {
      const {
        vehicleNo,
        id: vehicleId,
        vehicleName,
        isInterior = true,
      } = value;
      this.form.data = {
        ...this.form.data,
        vehicleNo,
        vehicleId,
        isInterior,
        vehicleName,
      };
      this.showCarSelect = false;
    },
    clearVehicle() {
      const newValue = {
        ...this.form.data,
        vehicleNo: "",
        vehicleId: "",
        vehicleName: "",
        isInterior: false,
      };
      delete newValue.vehicleId;
      this.form.data = newValue;
      this.showCarSelect = false;
    },

    refuelTypeChoose(refuel) {
      const { value } = refuel;
      this.form.data.refuelTypeCode = value;
      this.showRefuelPicker = false;
    },
    getRefuel(code) {
      return this.refuelTypeList.find((type) => type.code === code) || {};
    },
    handleClose() {
      this.form.data = { applyRefuelCap: this.refuelOption.max };
      this.$emit("closed");
    },
  },
};
</script>

<template>
  <van-popup
    v-model="showPop"
    round
    position="bottom"
    closeable
    close-icon-position="top-right"
    @closed="handleClose"
  >
    <div class="edit-pop">
      <div class="edit-pop-title">
        <div>{{ title }}</div>
        <div class="edit-pop-subtitle">加油申请</div>
      </div>
      <van-form ref="form" @submit="onSubmit">
        <van-field
          readonly
          clickable
          name="refuelTypeCode"
          :value="getRefuel(form.data.refuelTypeCode).label || ''"
          label="加油类型"
          placeholder="请选择加油类型"
          :rules="form.rules.refuelTypeCode"
          @click="showRefuelPicker = true"
        />
        <van-action-sheet
          v-model="showRefuelPicker"
          :actions="refuelDict"
          cancel-text="取消"
          description="选择加油状态"
          @select="refuelTypeChoose"
        />
        <van-field
          v-model="form.data.vehicleNo"
          :readonly="true"
          :clearable="!!form.data.vehicleId"
          clear-trigger="always"
          name="vehicleNo"
          label="车牌号"
          placeholder="请选择"
          :rules="form.rules.vehicleNo"
        >
          <div
            v-if="!form.data.vehicleId && !isUpdate"
            slot="button"
            style="color: #4e5969"
            @click="showCarSelect = true"
          >
            选择
          </div>
          <van-icon
            v-else-if="!isUpdate"
            slot="right-icon"
            name="close"
            @click="clearVehicle"
          />
        </van-field>
        <van-field
          v-model="form.data.vehicleName"
          :readonly="true"
          clear-trigger="always"
          name="vehicleName"
          label="车辆名称"
          placeholder="请选择车辆"
        />
        <van-field
          readonly
          clickable
          name="applyRefuelCap"
          :value="form.data.applyRefuelCap"
          label="申请加油量"
          placeholder="请输入"
          :rules="[
            { required: true, message: '请输入加油量', trigger: 'onChange' },
            {
              validator: validatorRefuelNum,
              message: `超出允许的加油量，最大${refuelOption.max}`,
              trigger: 'onChange',
            },
          ]"
          @click="showNumberInput = true"
        >
          <template slot="right-icon"> L </template>
        </van-field>
        <van-number-keyboard
          v-model="form.data.applyRefuelCap"
          theme="custom"
          :show="showNumberInput"
          :extra-key="['00', '.']"
          close-button-text="完成"
          @blur="showNumberInput = false"
        />
        <!-- 显示虚拟键盘的推高层 -->
        <div style="height: 184px" />
        <div style="margin: 16px">
          <van-button round block type="primary" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
    <CarSearch :visible.sync="showCarSelect" @selected="handleSelected" />
  </van-popup>
</template>

<style lang="scss" scoped>
.edit-pop {
  .edit-pop-title {
    font-size: 18px;
    font-weight: bold;
    padding: 16px 24px;
  }
  .edit-pop-subtitle {
    font-size: 14px;
    color: gray;
    font-weight: lighter;
  }
}
</style>